export const selectItvs = (state) => state.itvs;

export const selectItvList = (state) => state.itvs.list;
export const selectItvListLoading = (state) => state.itvs.loading;
export const selectItvListLoadingCount = (state) => state.itvs.loadingCount;
export const selectItvListError = (state) => state.itvs.error;
export const selectItvFilters = (state) => state.itvs.filters;